import { render } from "./MassDetail.vue?vue&type=template&id=41758bb8&scoped=true"
import script from "./MassDetail.vue?vue&type=script&lang=js"
export * from "./MassDetail.vue?vue&type=script&lang=js"

import "./MassDetail.vue?vue&type=style&index=0&id=41758bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41758bb8"]])

export default __exports__